import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { useGlobalDataContext } from "../../../GlobalDataContext";
import cx from "clsx";

import { eraseCookie } from "./../../utils/CookieService";

import { removeTokenData } from "../../components/Authorization/TokenServiceStorage";
import { removeItemFromStorage } from "../../utils/LocalStorageService";

import { getFloor } from "./../../utils/helpers";
import ScrambleEffectText from "../../components/ScrambleEffectText";
import LanguageDropdown from "../../components/ChangeLanguage/LanguageDropdown";

const LoginMenu = () => {
  const { state, dispatch } = useGlobalDataContext();
  const { t } = useTranslation();
  const [stakeAmountScrambleEffect, setStakeAmountScrambleEffect] = useState(
    false
  );
  // const [currentLang, setCurrentLang] = useState(
  //   Object.keys(i18n.options.resources).includes(i18n.language)
  //     ? i18n.language
  //     : "en"
  // );
  const logout = () => {
    console.log("LOGOUO do nothing");
  };

  const showHeaderMenuEventListener = event => {
    dispatch({
      type: "SLIDE_ASIDE_BLOCK",
      payload:
        event.currentTarget.getAttribute("data-aside-block") ===
        state.slideAsideBlockId
          ? null
          : event.currentTarget.getAttribute("data-aside-block")
    });
  };

  // open modal
  // eslint-disable-next-line
  const openModalEventListener = event => {
    const modalHref = event.currentTarget.getAttribute("data-modal");
    dispatch({
      type: "SLIDE_ASIDE_BLOCK",
      payload: null
    });

    // dispatch event for showing modal window
    dispatch({
      type: "OPEN_MODAL_WINDOW",
      payload: modalHref ? modalHref : null
    });
  };

  // eslint-disable-next-line
  const showSlideAsideBlockEventListener = event => {
    dispatch({
      type: "SLIDE_ASIDE_BLOCK",
      payload:
        event.currentTarget.getAttribute("data-aside-block") ===
        state.slideAsideBlockId
          ? null
          : event.currentTarget.getAttribute("data-aside-block")
    });
  };

  // const changeLanguageEventListener = e => {
  //   if (i18n.language === e.currentTarget.value) return;
  //   i18n.changeLanguage(e.currentTarget.value);
  // };

  // React.useEffect(() => {
  //   const currLang = Object.keys(i18n.options.resources).filter(lang => {
  //     return i18n.language === lang;
  //   })[0];
  //   setCurrentLang(currLang);
  //   // eslint-disable-next-line
  // }, [i18n.language]);

  // set stake amount scramble effect when credits are changed
  React.useEffect(() => {
    if (state.userData && state.userData.createWalletDTO.credits <= 0) return;
    setStakeAmountScrambleEffect(true);
    setTimeout(() => {
      setStakeAmountScrambleEffect(false);
    }, 900);
    // eslint-disable-next-line
  }, [state.appSettings.credits]);

  return (
    <>
      
      <div className="outer-language">
        <LanguageDropdown showLable={false}/>
      </div>
     
      <aside
        className={cx("header-slide-menu", {
          active: state.slideAsideBlockId === "headerSlideMenu"
        })}
      >
        <span onClick={showHeaderMenuEventListener} className="close-btn">
          {t("header.loginMenu.close")}
        </span>

        {/* <div className="header-slide-menu-item language">
          <span>{t("header.loginMenu.changeLang")}</span>
          <select
            placeholder={t("header.loginMenu.changeLang")}
            onChange={changeLanguageEventListener}
            defaultValue={currentLang}
            className={"select-lang"}
          >
            <option value="en">English</option>
            <option value="ru">Русский</option>
          </select>
        </div> */}
      </aside>

      {/*backdrop for side slide menu*/}
      <div
        onClick={showHeaderMenuEventListener}
        data-aside-block="headerSlideMenu"
        className={cx("modal-backdrop aside-menu-backdrop", {
          active: state.slideAsideBlockId === "headerSlideMenu"
        })}
      ></div>
    </>
  );
};

export default LoginMenu;
